module.exports = __webpack_public_path__ + "images/116_2048.jpg";